module.exports = __webpack_public_path__ + "img/box1_bg.5988eea1.png";